<template>
  <transition name="fade">
    <div
      class="modal"
      v-if="show && sendAuditArticle.length > 0"
      style="z-index:1001"
    >
      <div
        class="container"
        v-loading='sendLoading'
        element-loading-text="提交中,请稍后"
      >
        <div class="container_top msp_icon_close">
          <span
            class="container_top_title"
            v-if="sendAuditType === 'batchSendAudit' || sendAuditType === 'oneSendAudit' || sendAuditType === 'turnToOtherAudit'"
          >送审至他人</span>
          <span
            class="container_top_title"
            v-if="sendAuditType === 'shareToOther'"
          >分享至他人</span>

          <span
            class="container_top_title"
            v-if="sendAuditType === 'reporterChoice'"
          >选择记者</span>

          <span
            class="iconfont el-icon-close"
            v-on:click="closeModal()"
          ></span>
        </div>
        <div class="search_person">
          <input
            type="text"
            placeholder='请输入姓名查询'
            @keyup.enter='searchPersonData()'
            v-model='searchPersonKey'
            @click.stop='showMoreUserList()'
          >
          <img
            src="../../../static/img/search.png"
            alt=""
            @click.stop='searchPersonData()'
          >

        </div>
        <div class="more_user">
          <div class="more_user_content">
            <div class="more_user_content_title">
              <span>最近联系人：</span>
            </div>
            <div class="more_user_content_list">
              <div
                class="each_more_user_content"
                v-for="item in searchPersonList"
                @click.stop='choiceCurrentMoreUserList(item)'
              >
                <span>{{item.username}}</span>
                <img
                  src="../../../static/img/nochoice.png"
                  alt=""
                  v-if='!isShowCurrentMoreUser(item)'
                >
                <img
                  src="../../../static/img/clickchoice.png"
                  alt=""
                  v-if='isShowCurrentMoreUser(item)'
                >
              </div>
            </div>
          </div>
        </div>
        <div class="share_list">
          <div class="share_list_left share_mate">
            <div class="share_list_title">组织或部门</div>
            <el-scrollbar
              class="share_list_content"
              style="overflow:hidden;"
            >
              <el-tree
                :data="departDataList"
                show-checkbox
                node-key="id"
                ref='departTree'
                :check-on-click-node='true'
                @check-change="handleCheckChange"
                :filter-node-method="filterNode"
                :check-strictly='checkStricty'
                :props="defaultProps"
                :default-expanded-keys="defaultOpenId"
                :default-checked-keys="defaultCheckedKeysList"
              >
                <span
                  class="custom-tree-node"
                  slot-scope="{ node, data }"
                >
                  <img
                    src="../../../static/img/avatar.png"
                    alt=""
                    v-if="data.flag_user && !data.header_img"
                  >
                  <img
                    :src="data.header_img"
                    alt=""
                    v-if="data.flag_user && data.header_img"
                  >
                  <span>{{ node.label }}</span>
                  <span>
                  </span>
                </span>
              </el-tree>
            </el-scrollbar>

          </div>
          <div
            class="share_list_left share_list_right"
            style="display:none;"
          >
            <div class="share_list_title">
              <span>已选择人员</span>
              <span style="color:#51BD90;">{{userChoiceList.length}}</span>
              <span>个</span>
              <div
                class="clear_list"
                @click.stop="clearAllChoiceUser()"
              >清除</div>
            </div>
            <el-scrollbar
              class="share_list_content"
              style="overflow:hidden;"
            >
              <ul>
                <li v-for='(item,index) in userChoiceList'>
                  <div class="share_each">
                    <span class="sharch_name">{{item.name}}</span>
                    <div>
                      <div
                        class="share_clear"
                        @click.stop='deleteChoiceUser(item,index)'
                      >
                        <span class="iconfont el-icon-close"></span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </el-scrollbar>

          </div>
        </div>
        <div class="share_button">
          <!-- <div class="sure_cancle cancle_operate"
               @click.stop='closeModal()'>取&nbsp;&nbsp;消</div>
          <div class="sure_cancle"
               @click.stop='sureSendToOther()'
               style="background:#688EFF;">确&nbsp;&nbsp;定</div> -->
          <el-button @click.native='closeModal()'>取消</el-button>
          <el-button
            type="primary"
            @click.native='sureSendToOther()'
          >确定</el-button>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
import logsMixins from '../../../mixins/logs'
import Vue from 'vue'
export default {

  components: {

  },

  created () {


  },
  mixins: [logsMixins],

  mounted () {
    this.$root.eventHub.$on('sendAuditModel', (data, type, shareData) => {
      this.show = true
      this.sendAuditArticle = data
      this.sendAuditType = type
      if (type === 'shareToOther') {
        this.shareMediaData = shareData
      }
      if (type === 'reporterChoice') {
        if (shareData && shareData.length) {
          for (var i = 0; i < shareData.length; i++) {
            this.userChoiceList.push({ name: shareData[i].username, id: shareData[i].usercode })
            this.defaultCheckedKeysList.push(shareData[i].usercode)
          }
        }
      }
      this.getMoreUserList()
      this.getCompanyUserInfo()
    })
  },

  destroyed () {
    this.$root.eventHub.$off('sendAuditModel')
  },

  data () {
    return {
      show: false,
      userChoiceList: [],
      searchPersonKey: '',
      departDataList: [],
      sendAuditType: '',
      sendAuditArticle: [],
      searchPersonList: [],
      showSearchUl: false,
      shareMediaData: '',
      defaultOpenId: [],
      sendLoading: false,
      defaultCheckedKeysList: []
    }
  },


  computed: {
    defaultProps () {
      var option = {}
      if (this.sendAuditType === 'shareToOther' || this.sendAuditType === 'reporterChoice') {
        option = {
          children: 'children',
          label: 'name',
        }
      } else {
        option = {
          children: 'children',
          label: 'name',
          disabled (data, node) {
            return !data.flag_user
          }
        }
      }
      return option

    },
    checkStricty () {
      if (this.sendAuditType === 'shareToOther' || this.sendAuditType === 'reporterChoice') {
        return false
      } else {
        return true
      }
    },
    isShowCurrentMoreUser () {
      return function (item) {
        if (this.userChoiceList.length > 0) {
          var k = 0
          for (var i = 0; i < this.userChoiceList.length; i++) {
            if (this.userChoiceList[i].id !== item.usercode) {
              k++
            } else {
              break;
            }
          }
          if (k == this.userChoiceList.length) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
    }

  },

  methods: {
    closeModal () {
      this.show = false
    },
    searchPersonData () {
      this.$refs.departTree.filter(this.searchPersonKey)
      this.showSearchUl = false
    },
    handleCheckChange (data, checked, indeterminate) {
      if (this.sendAuditType === 'batchSendAudit' || this.sendAuditType === 'oneSendAudit' || this.sendAuditType === 'turnToOtherAudit') {
        if (checked) {
          var arr = this.$refs.departTree.getCheckedNodes()
          for (var i = 0; i < arr.length; i++) {
            this.$refs.departTree.setChecked(arr[i])
          }
          this.$refs.departTree.setChecked(data.id, true)
        }
        this.userChoiceList = this.$refs.departTree.getCheckedNodes()

      } else if (this.sendAuditType === 'shareToOther' || this.sendAuditType === 'reporterChoice') {
        var checkArr = this.$refs.departTree.getCheckedNodes()
        var arr = []
        for (var j = 0; j < checkArr.length; j++) {
          if (checkArr[j].flag_user) {
            arr.push(checkArr[j])
          }
        }
        this.userChoiceList = arr
      }
    },
    deleteChoiceUser (item, index) {
      this.userChoiceList.splice(index, 1)
      this.$refs.departTree.setChecked(item.id, false)
    },
    getCompanyUserInfo () {
      var getGroup = false
      if (this.sendAuditType === 'reporterChoice') {
        getGroup = true
      }
      var url = _USERURL_ + 'api/company/get_company_user_info' + '?get_group=' + getGroup
      var option = {
        ...this.$store.getters.baseOption,
        'params': {}
      }
      api._post(url, option).then((res) => {
        if (res.code == 200) {
          this.departDataList = [res.data]
          this.defaultOpenId = [this.departDataList[0].id]
        } else {
          this.departDataList = []
        }
      }).catch((error) => {
        console.log(error)
        this.departDataList = []
      })
    },

    // 获取常用联系人数据
    getMoreUserList () {
      var url = _USERURL_ + 'api/company/get_more_used_user'
      var option = {
        ...this.$store.getters.baseOption,
        'params': {}
      }
      api._post(url, option).then((res) => {
        if (res.code == 200) {
          this.searchPersonList = res.data
        } else {
          this.searchPersonList = []
        }
      }).catch((error) => {
        console.log(error)
        this.searchPersonList = []
      })
    },
    showMoreUserList () {
      this.showSearchUl = true
    },
    choiceCurrentMoreUserList (item) {
      this.showSearchUl = false

      if (this.userChoiceList.length > 0) {
        var k = 0
        for (var i = 0; i < this.userChoiceList.length; i++) {
          if (this.userChoiceList[i].id !== item.usercode) {
            k++
          } else {
            break;
          }
        }
        if (k == this.userChoiceList.length) {
          if (this.sendAuditType === 'batchSendAudit' || this.sendAuditType === 'oneSendAudit' || this.sendAuditType === 'turnToOtherAudit') {
            this.userChoiceList = [{ name: item.username, id: item.usercode }]
          } else if (this.sendAuditType === 'shareToOther' || this.sendAuditType === 'reporterChoice') {
            this.userChoiceList.push({ name: item.username, id: item.usercode })
          }

        }
        else {
          if (this.sendAuditType === 'batchSendAudit' || this.sendAuditType === 'oneSendAudit' || this.sendAuditType === 'turnToOtherAudit') {
            this.userChoiceList = []
          } else if (this.sendAuditType === 'shareToOther' || this.sendAuditType === 'reporterChoice') {
            for (var j = 0; j < this.userChoiceList.length; j++) {
              if (this.userChoiceList[j].id == item.usercode) {
                this.userChoiceList.splice(j, 1)
              }
            }
          }

        }
      } else {
        if (this.sendAuditType === 'batchSendAudit' || this.sendAuditType === 'oneSendAudit' || this.sendAuditType === 'turnToOtherAudit') {
          this.userChoiceList = [{ name: item.username, id: item.usercode }]
        } else if (this.sendAuditType === 'shareToOther' || this.sendAuditType === 'reporterChoice') {
          this.userChoiceList.push({ name: item.username, id: item.usercode })
        }

      }

      var arr = this.$refs.departTree.getCheckedNodes()
      for (var n = 0; n < arr.length; n++) {
        this.$refs.departTree.setChecked(arr[n])
      }

      for (var m = 0; m < this.userChoiceList.length; m++) {
        this.$refs.departTree.setChecked(this.userChoiceList[m].id, true)
      }

    },
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    clearAllChoiceUser () {
      for (var i = 0; i < this.userChoiceList.length; i++) {
        this.$refs.departTree.setChecked(this.userChoiceList[i].id, false)
      }
      this.userChoiceList = []
    },
    sureSendToOther () {
      if (this.sendAuditType === 'batchSendAudit') {
        if (this.userChoiceList.length > 0) {
          this.$root.eventHub.$emit('batchoperateModel', this.sendAuditArticle, 'batchoperateAudit', this.userChoiceList)
        } else {
          this.$notify.warning({
            title: '警告',
            message: '请选择送审人员'
          });
        }
      } else if (this.sendAuditType === 'oneSendAudit') {
        if (this.userChoiceList.length > 0) {
          var url = ''
          var idArr = []
          for (var i = 0; i < this.sendAuditArticle.length; i++) {
            idArr.push(this.sendAuditArticle[i].id)
          }
          if (this.sendAuditArticle[0].doc_type === 'document') {
            url = _API_ + 'api/article/doc/audit/batch_audit_request'
          } else {
            url = _API_ + 'api/article/audit/batch_audit_request'
          }

          var option = {
            ...this.$store.getters.baseOption,
            'params': {
              "list_id": idArr,    // 必须字段： 审核对象的 id 列表
              "content_type": "article",            // 必须字段：类型  稿件为  article
              "id_to_user": this.userChoiceList[0].id                   // 必须字段：指定的审核人的用户 ID
            }
          }
          this.sendLoading = true
          api._post(url, option).then((res) => {
            if (res.code == 200) {
              this.$notify.success({
                title: '成功',
                message: '提交送审成功'
              });
              for (var i = 0; i < this.sendAuditArticle.length; i++) {
                this.$set(this.sendAuditArticle[i], 'audit_status', 'doing')
              }
              if (this.$route.path === "/manuscriptrepo/myshare" || this.$route.path === "/documentrepo/myshare") {
                this.$root.eventHub.$emit('setMyShareArticleFlag', this.sendAuditArticle[0], '', 'sendAudit')
              }
              if (this.$route.path === "/manuscriptrepo/sharetome" || this.$route.path === "/documentrepo/sharetome") {
                this.$root.eventHub.$emit('setShareTomeArticleFlag', this.sendAuditArticle[0], '', 'sendAudit')
              }
              if (this.$route.path === "/manuscriptrepo/repomanuscript" || this.$route.path === "/documentrepo/repomanuscript") {
                this.$root.eventHub.$emit('setSendAuditStatus', this.sendAuditArticle[0], 'doing')
              }
              if (this.$route.path === "/editorArticle" || this.$route.path === "/atlasmanuscript") {
                try {
                  window.opener.postMessage(this.sendAuditArticle[0], '*')
                } catch (error) {
                  console.log(error)
                }
                this.$root.eventHub.$emit('getAuditInfoByArticleIdModel', '')
                eventButtonBus.$emit('getOperateArticleData', this.sendAuditArticle[0])
              }
              this.getAuditLogs(this.sendAuditArticle[0].id)
              this.getOperateLogs(this.sendAuditArticle[0].id)
              this.sendAuditArticle.splice(0, this.sendAuditArticle.length)
              this.$root.eventHub.$emit('setCurrentChoiceArticle', [])

            } else {
              this.$notify.error({
                title: '错误',
                message: '提交失败'
              });
            }
            this.sendLoading = false
          }).catch((error) => {
            this.$notify.error({
              title: '错误',
              message: '提交失败'
            });
            this.sendLoading = false
          })
        } else {
          this.$notify.warning({
            title: '警告',
            message: '请选择送审人员'
          });
        }

      }
      else if (this.sendAuditType === 'turnToOtherAudit') {
        if (this.userChoiceList.length > 0) {
          this.$root.eventHub.$emit('turnToOtherUser', this.userChoiceList)
          this.show = false
        } else {
          this.$notify.warning({
            title: '警告',
            message: '请选择转送审人员'
          });
        }
      }
      else if (this.sendAuditType === 'shareToOther') {
        if (this.userChoiceList.length > 0) {
          var shareUserId = []
          for (var i = 0; i < this.userChoiceList.length; i++) {
            shareUserId.push(this.userChoiceList[i].id)
          }
          var option = {
            ...this.$store.getters.baseOption,
            "params": {                           // 必须字段： 参数
              "articleId": this.sendAuditArticle[0].id, //稿件id
              "title": this.sendAuditArticle[0].title,    //稿件标题
              "canEdit": this.shareMediaData.editorChecked,  //能否编辑
              "remarks": this.shareMediaData.remarkDescrip,   //备注
              'invalidTime': this.shareMediaData.timeLostSize,
              "shareUserId": this.$store.state.userinfo.usercode,      //分享人id
              "sharedUserIds": shareUserId,
              'code': this.shareMediaData.codeInput,
              'doc_type': this.sendAuditArticle[0].doc_type
            }
          }
          this.sendLoading = true
          api._post(_SHAREURL_ + 'addShareInfo', option).then((res) => {
            if (res.code == 200) {
              this.$notify.success({
                title: '成功',
                message: '分享成功'
              })
              this.show = false
              this.sendAuditArticle.splice(0, this.sendAuditArticle.length)
            } else {
              this.$notify.error({
                title: '错误',
                message: '分享失败'
              });
            }
            this.sendLoading = false
          }).catch((error) => {
            this.$notify.error({
              title: '错误',
              message: '分享失败'
            });
            this.sendLoading = false
          })

        } else {
          this.$notify.warning({
            title: '警告',
            message: '请选择转分享人员'
          });
        }

      } else if (this.sendAuditType === 'reporterChoice') {
        this.$root.eventHub.$emit('choiceReporterModel', this.userChoiceList)
        this.show = false
      }
    }

  },

  watch: {
    show () {
      if (!this.show) {
        this.userChoiceList = []
        this.searchPersonKey = ''
        this.defaultCheckedKeysList = []
      }
    },
    sendAuditArticle () {
      if (this.sendAuditArticle.length === 0) {
        this.show = false
      }
    },
    searchPersonKey (val) {
      this.$refs.departTree.filter(val)
    }

  }
}

</script>

<style scoped>
.container {
  transition: all 1s ease;
  width: 650px;
  height: 760px;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px #999;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.container_top {
  width: 100%;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  clear: both;
  line-height: 48px;
  margin-bottom: 10px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px 6px 0 0;
  height: 48px;
  padding: 0 20px 0 20px !important;
  box-sizing: border-box;
}

.container_top .iconfont {
  float: right;
  font-size: 20px;
  cursor: pointer;
  color: #5f7094;
  line-height: 48px;
}

.container_top .container_top_title {
  color: #333333;
  font-size: 14px;
  float: left;
}

.search_person {
  width: 610px;
  height: 34px;
  margin-bottom: 16px;
  position: relative;
  border: 1px solid #c8c8c8;
  border-radius: 6px;
  padding-left: 20px;
  margin-left: 20px;
  background: #fbfcff;
  box-sizing: border-box;
}

.search_person input {
  width: 520px;
  height: 30px;
  border: none;
  outline: none;
  background: #fff;
  color: #666666;
  font-size: 14px;
}

.search_person img {
  position: absolute;
  right: 20px;
  top: 8px;
  cursor: pointer;
}

.more_user {
  width: 100%;
  height: 110px;
  margin-bottom: 16px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}
.more_user_content {
  height: 110px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid #c8c8c8;
  border-radius: 6px;
  padding: 10px 0px 0 10px;
  box-sizing: border-box;
}
.more_user_content span {
  color: #606266;
  font-size: 14px;
}
.more_user_content_title {
  margin-bottom: 10px;
}
.more_user_content_list {
  clear: both;
  height: 66px;
  overflow: auto;
}
.each_more_user_content {
  float: left;
  margin-right: 20px;
  margin-bottom: 10px;
  display: flex;
  height: 20px;
  align-items: center;
  cursor: pointer;
}
.each_more_user_content img {
  display: block;
  border: none;
  margin-left: 8px;
}
.share_list {
  width: 100%;
  flex: 1;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  box-sizing: border-box;
}

.share_list_left {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #c8c8c8;
  border-radius: 6px;
}

.share_list_right {
  margin-left: 20px;
}

.share_list_title {
  width: 100%;
  height: 44px;
  line-height: 44px;
  color: #333333;
  font-size: 12px;
  padding-left: 10px;
  border-bottom: 1px solid #c8c8c8;
  margin-bottom: 10px;
  box-sizing: border-box;
  clear: both;
  padding-right: 20px;
}
.clear_list {
  float: right;
  color: #fd4a4a;
  font-size: 14px;
  cursor: pointer;
}
.share_list_content {
  width: 100%;
  height: 390px;
  overflow: auto;
}

.share_list_content .share_each {
  width: 100%;
  height: 34px;
  line-height: 34px;
  padding-left: 10px;
  position: relative;
  box-sizing: border-box;
}

.share_each .iconfont {
  color: #b5caec;
  font-size: 14px;
  cursor: pointer;
}

.share_each .sharch_name {
  color: #666666;
  font-size: 12px;
}

.share_each img {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  position: absolute;
  left: 26px;
  top: 7px;
}

.sharch_name_second {
  padding-left: 44px;
}

.share_clear {
  position: absolute;
  right: 20px;
  top: 8px;
  width: 16px;
  height: 16px;
  background: #f86c7d;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  line-height: 13px;
}

.share_clear .iconfont {
  font-size: 12px;
  color: #fff;
}
.share_clear .iconfont:hover {
  color: #fff !important;
}

.share_button {
  width: 100%;
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share_button button {
  width: 78px;
  height: 32px;
  padding: 0px;
  line-height: 32px;
  text-align: center;
}

.sure_cancle {
  width: 110px;
  height: 36px;
  border-radius: 4px;
  background: #688eff;
  line-height: 36px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.cancle_operate {
  background: #fff;
  color: #666666;
  border: 1px solid #dcdfe6;
  margin-right: 20px;
}
.custom-tree-node {
  display: flex;
}
.custom-tree-node img {
  width: 18px;
  height: 18px;
  display: block;
  margin-right: 6px;
  border-radius: 50%;
}
</style>
